declare var swal: any;
import { Component, OnInit } from '@angular/core';
import { NgbDateStruct, NgbModal, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgbRegisteredPatientModal } from './modal/registeredpatient.modal';
import { NgbGuestPatientModal } from './modal/guestpatient.modal';
import { NgbTypeofPatientModal } from './modal/typeofpatient.modal';
import { DoctorsListController, DoctorAppointmentsByDoctorcodeContoller, DoctorAppointmentsByDoctorCodeRequest, AppointmentDetailsByAppointmentCodeController, AppointmentDetailsByAppointmentCodeRequest, DoctorsListRequest, ProviderAvlSlotsRequest, ProviderAvlSlotsController, AppointmentCancelRequest } from '../../../models/actor/actor';
import * as alertFunctions from '../../../../shared/data/sweet-alerts';
import { AppData } from '../../../models/appdata';
import { ApiResponseModel } from '../../../models/api_response_model';
import { ActorService } from '../../../services/actor.service';
import { SpinnerService } from '../../../services/spinner.service';
import { DoctorListPipe, PatientListPipe } from '../../../pipes/actors/actorIdentity.pipes';
import { NGXToastrService } from '../../../../shared/services/toastr.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-fdappointment',
  templateUrl: './fdappointment.component.html',
  styleUrls: ['./fdappointment.component.css']
})
export class FdappointmentComponent implements OnInit {
  public ShowList: boolean = true; 
  public ShowList1: boolean = true; 
  public ShowList2: boolean = true;
  public AvailableSlots: boolean = true;
  public User: boolean = false;
  public ShowButton: boolean = true;
  public PatientDetails: boolean = false;
  public Final: boolean = false;
  public BranchName: string;
  public Final1: boolean = false;
  public Registeredpatient: boolean = false;
  public Regconfirm: boolean = false;
    public AppList: boolean = false;
    public isLoading: boolean = false;
  public PresentDate: Date;
    public DateSelected: Date;
    public ChangedDate: Date;
  public DisplayPresentDate: boolean = true;
    public DisplaySelectedDate: boolean = false;
    public DisplayChangedDate: boolean = false;
    SelectedFromDate: NgbDateStruct;
    public SelectedDatenew: Date;
  TodayDate = new Date();
    ValidFrom: NgbDateStruct;
    CurrentAppointmentCancelRequest: AppointmentCancelRequest;
    constructor(private actorservice: ActorService,
        private loaderService: SpinnerService,
        private filter: DoctorListPipe,
        private filter1: PatientListPipe,
        private tosterservice: NGXToastrService,
        private parserFormatter: NgbDateParserFormatter,
        private modalService: NgbModal,
        private spinner: NgxSpinnerService,

    ) { }

    ngOnInit() {
   //     this.SelectedToDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 2, day: this.TodayDate.getDate() };
        //this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
      this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
      this.PresentDate = new Date();
      this.LoadDoctorsList();
        this.BranchName = AppData.Instance().SelectedBranchName;
        this.CurrentAppointmentCancelRequest = new AppointmentCancelRequest();

        this.CurrentAppointmentCancelRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        //this.CurrentSavePatientVisitInformationRequest = new SavePatientVisitRequest();

        //this.CurrentSavePatientVisitInformationRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    }
  viewservice() {
    this.ShowList = true;
    //this.ShowList1 = true;
    this.AvailableSlots = true;
    this.ShowButton = false;
    this.ShowList2 = false;
    this.User = false;
  }
  applist() {
    this.ShowList = true;
    this.AvailableSlots = true;
    this.AppList = true;
    this.ShowList1 = false;
    this.ShowList2 = false;
    this.ShowButton = false;
    this.User = false;
  }
  applist1() {
    this.ShowList = true;
    this.AvailableSlots = true;
    this.AppList = false;
    this.ShowList1 = true;
    this.ShowList2 = false;
    this.ShowButton = false;
    this.User = false;
  }
  Patient1() {
    this.ShowList = false;
    this.AvailableSlots = false;
    this.ShowButton = false;
    this.User = true;
  }
  guestpatient() {
    this.ShowList = false;
    this.AvailableSlots = false;
    this.ShowButton = false;
    this.User = false;
    this.PatientDetails = true;
  }
  regpatient() {
    this.ShowList = false;
    this.AvailableSlots = false;
    this.ShowButton = false;
    this.User = false;
    this.PatientDetails = false;
    this.Registeredpatient = true;
    this.Final = false;
    this.Final1 = false;
  }
  BacktoList() {
    this.ShowList = false;
    this.AvailableSlots = false;
    this.ShowButton = false;
    this.User = true;
    this.PatientDetails = false;
  }
  Confirm() {
    this.ShowList = false;
    this.AvailableSlots = false;
    this.ShowButton = false;
    this.User = false;
    this.PatientDetails = false;
    this.Final = true;
  }
  Confirm1() {
    this.ShowList = false;
    this.AvailableSlots = false;
    this.ShowButton = false;
    this.User = false;
    this.PatientDetails = false;
    this.Final1 = true;
    this.Final = false;
    this.Regconfirm = false;
  }
  regconfirm() {
    this.ShowList = false;
    this.AvailableSlots = false;
    this.ShowButton = false;
    this.User = false;
    this.PatientDetails = false;
    this.Regconfirm = true;
    this.Final = false;
    this.Registeredpatient = false;
  }
  BacktoList1() {
    this.ShowList = true;
    this.AvailableSlots = false;
    this.ShowButton = false;
    this.User = false;
    this.PatientDetails = false;
    this.Final = false;
  }
  Patient() {
    const modalRef = this.modalService.open(NgbTypeofPatientModal,
      {
        centered: true,
        size: "lg"
      })
  }
    regpatientmodal(p: ProviderAvlSlotsController) {
    const modalRef = this.modalService.open(NgbRegisteredPatientModal,
      {
        centered: true,
        size: "lg"
        })
 
        modalRef.componentInstance.ProviderAvlSlotsController = p;
        modalRef.componentInstance.SelectedDoctor = this.SelectedDoctorData;
        //modalRef.componentInstance.FormattedCode = 
        modalRef.result.then(x => {
          this._GetProviderAvlSlotsContoller();
          this.LoadDoctorAppointmentsByDoctor();
        //    this.GetIvfPlanTemplateController()
      })
      
  }
  guestpatientmodal() {
    const modalRef = this.modalService.open(NgbGuestPatientModal,
      {
        centered: true,
          size: "lg"
      })
  }
    ProviderSlots : ProviderAvlSlotsController[];
    CurrentDoctorAppointmentsByDoctorcodeController: DoctorAppointmentsByDoctorcodeContoller[];
    CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest: DoctorAppointmentsByDoctorCodeRequest;
    SelectedAppointmentDetailsByAppointmentCodeController: AppointmentDetailsByAppointmentCodeController[];
    SelectedAppointmentDetails: AppointmentDetailsByAppointmentCodeController;
    LoadDoctorAppointmentsByDoctor() {
        this.CurrentDoctorAppointmentsByDoctorcodeController = new Array<DoctorAppointmentsByDoctorcodeContoller>();

        this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest = new DoctorAppointmentsByDoctorCodeRequest();
        this.pdata1 = this.CurrentDoctorAppointmentsByDoctorcodeController;
        this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ConditionalOperator = 15;
        //this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ProviderCode = null;
        this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
        this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
        this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetDoctorAppointmentsByDoctorcodeContoller();
    }

    SelectedApptData: DoctorAppointmentsByDoctorcodeContoller;
    AppointmentsListItemSelected(data: DoctorAppointmentsByDoctorcodeContoller) {
        //alert("appointment selected: " + data.PatientName);
        this.DoctorsList = true;
        this.SelectedDoctor = true;
        this.SelectedPatient = true;
        this.SelectedApptData = data;
        this.LoadAppointmentDetailsByAppointmentCode(data.AppointmentCode);

    }
    LoadAppointmentDetailsByAppointmentCode(AppointmentCode: number) {
        var request: AppointmentDetailsByAppointmentCodeRequest = new AppointmentDetailsByAppointmentCodeRequest();
        request.ConditionalOperator = 10;
        request.AppointmentCode = AppointmentCode;
        request.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetAppointmentDetailsByAppointmentCodeContoller(request);

    }

    GetAppointmentDetailsByAppointmentCodeContoller(request: AppointmentDetailsByAppointmentCodeRequest) {
        // alert(this.SelectedDoctorData.ProviderCode);
        //this.StartRefreshing();
        this.actorservice.GetAppointmentDetailsByAppointmentCodeContoller(request)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    //alert();
                    this.SelectedAppointmentDetailsByAppointmentCodeController = this.ApiResData.Result || (this.ApiResData as any).result || [];
                    //alert(this.SelectedAppointmentDetailsByAppointmentCodeController.length);
                    if (this.SelectedAppointmentDetailsByAppointmentCodeController.length > 0)
                        this.SelectedAppointmentDetails = this.SelectedAppointmentDetailsByAppointmentCodeController[0];
                    // alert(this.CurrentDoctorAppointmentsByDoctorcodeController.length);

                    //this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );

    }
    GetDoctorAppointmentsByDoctorcodeContoller() {
        // alert(this.SelectedDoctorData.ProviderCode);
        //this.StartRefreshing();
        this.isLoading = true;
        this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ProviderCode = this.SelectedDoctorData.ProviderCode;
        // this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.FromDate = "";
        this.actorservice.GetDoctorAppointmentsByDoctorcodeContoller(this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    //alert();
                    this.CurrentDoctorAppointmentsByDoctorcodeController = this.ApiResData.Result || (this.ApiResData as any).result || [];
                    this.pdata1 = this.CurrentDoctorAppointmentsByDoctorcodeController;
                    // alert(this.CurrentDoctorAppointmentsByDoctorcodeController.length);
                    this.isLoading = false;
                    //this.stopRefreshing();
                    //this.LoadAppoinmentDate();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );

    }
//    AppoinmentData: DoctorAppointmentsByDoctorcodeContoller[];
//    LoadAppoinmentDate() {
//        this._GetDoctorAppointmentsByDoctorcodeContollernew();
//    }
//    _GetDoctorAppointmentsByDoctorcodeContollernew() {
//    // alert(this.SelectedDoctorData.ProviderCode);
//        this.StartRefreshing();
//        this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ConditionalOperator = 15;
//    this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ProviderCode = this.SelectedDoctorData.ProviderCode;
//    // this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.FromDate = "";
//    this.actorservice.GetDoctorAppointmentsByDoctorcodeContoller(this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest)
//        .subscribe((result) => {
//            this.ApiResData = result;
//            if (!this.ApiResData.hasError) {

//                //alert();
//                this.CurrentDoctorAppointmentsByDoctorcodeController = this.ApiResData.Result;
//                this.AppoinmentData = this.ApiResData.Result;
//                //this.pdata1 = this.CurrentDoctorAppointmentsByDoctorcodeController;
//                // alert(this.CurrentDoctorAppointmentsByDoctorcodeController.length);

//                this.stopRefreshing();

//            }
//            else {
//                this.stopRefreshing();
//                if (this.ApiResData.ErrorData != "") {

//                    alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
//                }
//                else {
//                    alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
//                }
//            }

//        },


//            (error) => {

//                if (error == "401 - Unauthorized") {
//                    alertFunctions.AlertParamEr(error);
//                    this.stopRefreshing();



//                }
//                else {
//                    alertFunctions.AlertParamEr(error);
//                    this.stopRefreshing();
//                }
//            }


//        );

//}
    CurrentDoctorsListController: DoctorsListController[];
    CurrentDoctorsListRequest: DoctorsListRequest;
    ProviderAvlSlotsRequest: ProviderAvlSlotsRequest;
    GetProviderAvlSlotsContoller() {
        //  alert("load slots...")
        this.spinner.show();
        this.ProviderAvlSlotsRequest = new ProviderAvlSlotsRequest();
        this.ProviderAvlSlotsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.ProviderAvlSlotsRequest.ConditionalOperator = 10;
        this.ProviderAvlSlotsRequest.Duration = 15;
        this.ProviderAvlSlotsRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
        this.ProviderAvlSlotsRequest.Branch = AppData.Instance().SelectedBranchCode;
      this.ProviderAvlSlotsRequest.FromDate = new Date();
      
        this.ProviderAvlSlotsRequest.ToDate = new Date((new Date()).getTime() + (60 * 60 * 24 * 1000));
        // alert(this.SelectedDoctorData.ProviderCode);
        //this.StartRefreshing();
        this.ProviderAvlSlotsRequest.ProviderCode = this.SelectedDoctorData.ProviderCode;
        // this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.FromDate = "";
        this.actorservice.GetProviderAvlSlotsContoller(this.ProviderAvlSlotsRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    //alert();
                    this.ProviderSlots = this.ApiResData.Result || (this.ApiResData as any).result || [];
                    this.spinner.hide();
                  //  this.pdata1 = this.CurrentDoctorAppointmentsByDoctorcodeController;
                    // alert(this.CurrentDoctorAppointmentsByDoctorcodeController.length);

                    this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    this.spinner.hide();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();

                        

                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );

    }
    dataChanged(newobj) {
        //this.ChangedDate = newobj;
        this.DisplayPresentDate = false;
        this.DisplaySelectedDate = false;
        this.DisplayChangedDate = true;
        this._GetProviderAvlSlotsContoller();
        this._GetDoctorAppointmentsByDoctorcodeContoller();
  }
  _GetProviderAvlSlotsContoller() {
      //  alert("load slots...")
      this.spinner.show()
    this.ProviderAvlSlotsRequest = new ProviderAvlSlotsRequest();
    this.ProviderAvlSlotsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.ProviderAvlSlotsRequest.ConditionalOperator = 10;
    this.ProviderAvlSlotsRequest.Duration = 15;
    this.ProviderAvlSlotsRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
      this.ProviderAvlSlotsRequest.Branch = AppData.Instance().SelectedBranchCode;
      this.ProviderAvlSlotsRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
      this.ChangedDate = this.ProviderAvlSlotsRequest.FromDate;
      this.DateSelected = this.ProviderAvlSlotsRequest.FromDate;
      this.SelectedDatenew = new Date(this.parserFormatter.format(this.SelectedFromDate));
      this.ProviderAvlSlotsRequest.ToDate = new Date((this.SelectedDatenew).getTime() + (60 * 60 * 24 * 1000)) ;
        //new Date((new Date()).getTime() + (60 * 60 * 24 * 1000));
    // alert(this.SelectedDoctorData.ProviderCode);
    //this.StartRefreshing();
    this.ProviderAvlSlotsRequest.ProviderCode = this.SelectedDoctorData.ProviderCode;
    // this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.FromDate = "";
    this.actorservice.GetProviderAvlSlotsContoller(this.ProviderAvlSlotsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //alert();
            this.ProviderSlots = this.ApiResData.Result || (this.ApiResData as any).result || [];
            this.spinner.hide();
          //  this.pdata1 = this.CurrentDoctorAppointmentsByDoctorcodeController;
          // alert(this.CurrentDoctorAppointmentsByDoctorcodeController.length);

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

    }
    _GetDoctorAppointmentsByDoctorcodeContoller() {
        // alert(this.SelectedDoctorData.ProviderCode);
        //this.StartRefreshing();
        this.isLoading = true;
        this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ProviderCode = this.SelectedDoctorData.ProviderCode;
        this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ConditionalOperator = 15;
        //this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ProviderCode = null;
        this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
        this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
        // this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.FromDate = "";
        this.actorservice.GetDoctorAppointmentsByDoctorcodeContoller(this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    //alert();
                    this.CurrentDoctorAppointmentsByDoctorcodeController = this.ApiResData.Result || (this.ApiResData as any).result || [];
                    this.pdata1 = this.CurrentDoctorAppointmentsByDoctorcodeController;
                    // alert(this.CurrentDoctorAppointmentsByDoctorcodeController.length);
                    this.isLoading = false;
                    //this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );

    }
   
    LoadDoctorsList(SelectedFacility?: number) {
        const facility = Number(SelectedFacility) || Number((this as any).SelectedFacilityCode) || AppData.Instance().SelectedBranchCode || 1;
        this.CurrentDoctorsListController = new Array<DoctorsListController>();

        this.CurrentDoctorsListRequest = new DoctorsListRequest();
        this.pdata = this.CurrentDoctorsListController;
        this.CurrentDoctorsListRequest.ConditionalOperator = 20;
        this.CurrentDoctorsListRequest.FacilityCode = facility;
        this.CurrentDoctorsListRequest.ProvidersSpecality = "";
        this.CurrentDoctorsListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetDoctorsListController();
    }
    GetDoctorsListController() {
        this.StartRefreshing();

        this.actorservice.GetDoctorsListController(this.CurrentDoctorsListRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    //alert();
                    this.CurrentDoctorsListController = this.ApiResData.Result || (this.ApiResData as any).result || [];
                    this.pdata = this.CurrentDoctorsListController;
                    if (this.pdata && this.pdata.length > 0 && !(this as any).SelectedDoctorData) {
                        if (typeof (this as any).DoctorListItemSelected === 'function') {
                            (this as any).DoctorListItemSelected(this.pdata[0]);
                        }
                    }

                    this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );

    }
    SelectedDoctorData: DoctorsListController;
    DoctorListItemSelected(doctor: DoctorsListController) {
        this.SelectedDoctorData = doctor;
        // alert(this.SelectedDoctorData.DisplayName);
        this.DoctorsList = true;
        this.SelectedDoctor = true;
        this.SelectedPatient = false;

        // show selected doctor info..
        // if any speciffics are requried...
        // load doctor's appointments of today, default
        this.LoadDoctorAppointmentsByDoctor();
        this.GetProviderAvlSlotsContoller();
    }
    public ApiResData: ApiResponseModel;
    public isRequesting: boolean = false;
    public DoctorsList: boolean = true;
    public SelectedDoctor: boolean = false;
    public SelectedPatient: boolean = false;
    private stopRefreshing() {
        this.loaderService.displayLoader(false);
        this.isRequesting = false;
    }
    private StartRefreshing() {
        this.loaderService.displayLoader(true);
        this.isRequesting = true;
    }
    pdata: any[];
    listFilter: string;
    ngOnChanges(changes: any) {
        if (JSON.stringify(changes).indexOf("data") != -1)
            this.pdata = this.CurrentDoctorsListController;

        this.criteriaChange(this.listFilter);
    }
    criteriaChange(value: any) {
        if (this.filter != null) {
            if (value != '[object Event]') {
                this.listFilter = value;
                //alert(this.listFilter);
                this.pdata = this.filter.transform(this.CurrentDoctorsListController, this.listFilter);
            }
        }
    }

    pdata1: any[];
    listFilter1: string;
    ngOnChanges1(changes: any) {
        if (JSON.stringify(changes).indexOf("data") != -1)
            this.pdata1 = this.CurrentDoctorAppointmentsByDoctorcodeController;

        this.criteriaChange1(this.listFilter1);
    }
    criteriaChange1(value: any) {
        if (this.filter1 != null) {
            if (value != '[object Event]') {
                this.listFilter1 = value;
                //alert(this.listFilter);
                this.pdata1 = this.filter1.transform(this.CurrentDoctorAppointmentsByDoctorcodeController, this.listFilter1);
            }
        }
    }
  DecrementDate(Value: any) {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);
      var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
        monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

    //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth()+1, day: d.getDate() };
    //this.RefreshPatientsByDate();
    this._GetProviderAvlSlotsContoller();
    this.DisplayPresentDate = false;
      this.DisplaySelectedDate = true;
      this._GetDoctorAppointmentsByDoctorcodeContoller();
     // this.LoadDoctorAppointmentsByDoctor();
      //this.CurrentDoctorAppointmentsByDoctorcodeController = null;
    //ind++;
      
  }
  IncrementDate(Value: any) {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);
      var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
        monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

    //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth()+1, day: d.getDate() };
    
    this._GetProviderAvlSlotsContoller();
    this.DisplayPresentDate = false;
      this.DisplaySelectedDate = true;
      this._GetDoctorAppointmentsByDoctorcodeContoller();
    //this.RefreshPatientsByDate();
    //ind++;
  }
    cancel() {
        swal({
            title: 'Do You Want To Cancel Appoinment?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0CC27E',
            cancelButtonColor: '#FF586B',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            confirmButtonClass: 'btn btn-success btn-raised mr-5',
            cancelButtonClass: 'btn btn-danger btn-raised',
            buttonsStyling: false
        }).then(() => {

            this.CancelAppoinment();

            //this.DeleteActorIdentitiesMedicine(l);
            // alertFunctions.AlertParam('Delete Successfully...!');

        }, function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === 'cancel') {
                swal(
                    'Cancelled',
                    'Saving Operation Cancelled :)',
                    'error'
                )
            }
        })
    }
    CancelAppoinment() {
        console.log('..................');
        //  this.StartRefreshing();
        this.CurrentAppointmentCancelRequest.ConditionalOperator = 15;
        this.CurrentAppointmentCancelRequest.BranchCode = AppData.Instance().SelectedBranchCode;
        this.CurrentAppointmentCancelRequest.AppointmentCode = this.SelectedAppointmentDetails.AppointmentCode;
       
        //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
        //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;


        //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.actorservice.SaveAppointmentInformation2(this.CurrentAppointmentCancelRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.clearData2();

                        //alertFunctions.AlertParam('Deleted Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        this._GetDoctorAppointmentsByDoctorcodeContoller();
                        this._GetProviderAvlSlotsContoller();
                        //this.Load
                        //this.LoadScansData();
                        //this.LoadOvaryData();
                        //this.LoadTestData();
                        //this.LoadMedicineData();
                        //this.ShowList = true;
                        //this.LoadMedicineData();
                        // this.stopRefreshing();

                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.AlertParam("Invalid Operation...!");
                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                    }
                }
            );


    }

}
